import { render, staticRenderFns } from "./MessageSettingsForSite.vue?vue&type=template&id=5dd276ee&scoped=true&"
import script from "./MessageSettingsForSite.vue?vue&type=script&lang=js&"
export * from "./MessageSettingsForSite.vue?vue&type=script&lang=js&"
import style0 from "./MessageSettingsForSite.vue?vue&type=style&index=0&id=5dd276ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd276ee",
  null
  
)

export default component.exports